export const RED = "#ff7882";
export const YELLOW = "#E4C121";
export const GREEN = "#5DBB54";
